import styled from 'styled-components';
import img from '../../wall_12.jpg';

const Wrapper = styled.header`
  margin: 0 auto;
  padding: 100px 50px;
  text-align: center;
  height: 300px;
  background-image: url(${img});
  background-size: cover;
`;

export default Wrapper;